//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    mapActions
} from "vuex";
import logger from "@/utils/logger";

export default {
    data() {
        return {
          create: false,
          loadAll: true,
            init: true,
            loading: false,
            selected: [],
            pagination: {
        rowsPerPage: 0
      },
            orderItems: [],
            columns: [{
                    name: "supplierName",
                    align: "left",
                    label: "Leverandør navn",
                    field: "supplierName",
                    sortable: true,
                },
                {
                    name: "productNumber",
                    align: "left",
                    label: "Produktnummer",
                    field: "productNumber",
                    sortable: true,
                },
                {
                    name: "productName",
                    align: "left",
                    label: "Produktnavn",
                    field: "productName",
                    sortable: true,
                },
                {
                    name: "productUnit",
                    align: "left",
                    label: "Enhet",
                    field: "productUnit",
                    sortable: true,
                },
                {
                    name: "ItemsInStock",
                    align: "left",
                    label: "På lager",
                    field: "itemsInStock",
                    sortable: true,
                },
                {
                    name: "ItemsOutgoing",
                    align: "left",
                    label: "På vei ut",
                    field: "itemsOutgoing",
                    sortable: true,
                },
                {
                    name: "ItemsIncoming",
                    align: "left",
                    label: "På vei inn",
                    field: "itemsIncoming",
                    sortable: true,
                },
                {
                    name: "Minimum",
                    align: "left",
                    label: "Min",
                    field: "minimum",
                    sortable: true,
                },
                {
                    name: "Maximum",
                    align: "left",
                    label: "Maks",
                    field: "maximum",
                    sortable: true,
                },
                {
                    name: "numberOfItems",
                    align: "left",
                    label: "Antall til bestilling",
                    field: "numberOfItems",
                    sortable: true,
                },
            ],
            allDataLoaded: false, // Indikerer at all data er lastet
            pageSize: 5, // Antall rader per kall
            cursor: null,
            componentAlive: null,
        };
    },

    async mounted() {
      // logger.log("mounted")
        this.componentAlive = true;
        await this.refresh();
        this.init = false;
    },
    beforeDestroy() {
      // logger.log("beforeDestroy")
        this.componentAlive = false;
    },
    methods: {
        async refresh() {
          this.cursor= null;
          this.create = false;
          this.allDataLoaded = false;
            this.orderItems = [];
            await this.fetchMoreData()
        },

        onVirtualScroll(payload) {
            // logger.log("onVirtualScroll:", payload);
            // logger.log("onVirtualScroll, orderItems:", this.orderItems);
            // logger.log("onVirtualScroll, loading:", this.loading);
            // logger.log("onVirtualScroll, allDataLoaded:", this.allDataLoaded);

            if (payload.direction == "increase" && payload.to >= this.orderItems.length - 3 && !this.loading && !this.allDataLoaded) {
                this.fetchMoreData();
            }
            // else {
            //   logger.log("onVirtualScroll, no fetch:", this.allDataLoaded);
            // }
        },

        async fetchMoreData() {
            // logger.log("fetchMoreData");

            if(this.componentAlive == false){
              // logger.log("exit fetchMoreData, Killed");
              return;
            }

            const params = {
                pageSize: this.pageSize
            };
            if (this.cursor) {
                params.cursor = this.cursor;
            } else {
                params.cursor = 0;
            }

            if (this.loading) {
                // logger.log("exit fetchMoreData, loading");
                return;
            }

            this.loading = true;
            let sortBy = "SupplierName";

            const sortColumn = this.columns.find(col => col.name === sortBy);
            if (!sortColumn || !sortColumn.sortable) {
                sortBy = "SupplierName";
            }

            try {
                const fetched = await this.getReferencesVirtualScrollSuggestedOrderItems(params);
                //this.orderItems = this.orderItems.concat(fetched.data);
                this.orderItems.push(...fetched.data);
                this.cursor = fetched.nextCursor;
                // logger.log("cursor:" + this.cursor)

                if (this.cursor == null) {
                    // logger.log("All loaded")
                    this.allDataLoaded = true;
                } else {
                    if (fetched.data.length == 0) {
                        // logger.log("timeout, fetchMoreData med ny cursor");
                        this.loading = false;
                        await this.fetchMoreData();
                    }
                    else if(this.loadAll){
                      this.loading = false;
                      await this.fetchMoreData();
                    }
                }

            } catch (error) {
                console.error("Error fetching items:", error);
                this.$q.notify({
                    type: "negative",
                    message: this.$t("common.errorFetchingData")
                });
            } finally {
                this.loading = false;
            }

        },

        async createPurchaseOrders() {
          this.create = true;
            var items = [];
            this.selected.forEach(function (item) {
                var newItem = {};
                newItem.productId = item.productId;
                newItem.itemText = item.productName;
                newItem.numberOfItems = item.numberOfItems;
                items.push(newItem);
            });

            try {

                await this.postPurchaseOrderFromOrderItems(items);
                this.refresh();
                this.selected = [];
                this.$q.notify({
                    type: "positive",
                    message: this.$t("common.saveOk"),
                });
            } catch (error) {
                logger.log("error", error);
                this.$q.notify({
                    type: "negative",
                    message: `${this.$t(
            "common.errorSave"
          )}. ${this.$utils.GetErrorMessage(error)}`,
                });
            }
        },

        ...mapActions("main", [
            //"getSuggestedOrderItems",
            "postPurchaseOrderFromOrderItems",
            "getReferencesVirtualScrollSuggestedOrderItems"
        ]),
    },
};
